import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Workspace.css'

import Card from './Card'

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
}

const defaultProps = {
  tag: 'div'
}

const Workspace = (props) => {
  const {
    className,
    fluid,
    tag: Tag,
    ...attributes
  } = props

  const classes = classNames(
    className,
    styles.workspace
  )

  return (
    <Card
      {...attributes}
      className={classes}
    />
  )
}

Workspace.propTypes = propTypes
Workspace.defaultProps = defaultProps

export default Workspace
